<ejs-maskedtextbox mask='00:00'
                   [(value)]="innerDuration"
                   floatLabelType="Never"
                   showClearButton="true"
                   (blur)="onBlur()"
                   [ngClass]="styleClass"
                   [ngStyle]="inputStyle"
                   [enabled]="!disabled"></ejs-maskedtextbox>
